// @flow

import { combineReducers } from 'redux';

import type { State as coreState } from '../core/reducer';
import type { State as authenticationState } from '../authentication/reducer';
import type { State as timeClockState } from '../timeClock/reducer';
import core, { initialState as coreInitialState } from '../core/reducer';
import authentication, {
  initialState as authenticationInitialState
} from '../authentication/reducer';
import timeClock, { initialState as timeClockInitialState } from '../timeClock/reducer';

export type State = {|
  core: coreState,
  authentication: authenticationState,
  timeClock: timeClockState
|};

const reducers = {
  core,
  authentication,
  timeClock
};

export const initialState: State = {
  core: { ...coreInitialState },
  authentication: { ...authenticationInitialState },
  timeClock: { ...timeClockInitialState }
};

export default combineReducers(reducers);
